



import type { TargetAndTransition, Variants } from "framer-motion";
import type { MotionProps } from "framer-motion";


export const fadeInUp: Variants = {
 hidden: {
    opacity: 0,
    y: 30,
    scale: 0.98,
  },
  show: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      damping: 25,
      stiffness: 120,
      mass: 0.8,
    },
  },
};


export const itemVariants:Variants = {
  hidden: { opacity: 0, scale: 0.5, x: 50 },
  visible: {
    opacity: 1,
    scale: 1,
    x: 0,
    transition: {
      type: "spring",
      damping: 20,
      stiffness: 300,
    },
  },
};
export const mobileContainerVariants:Variants = {
  hidden: { opacity: 0, y: 100 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 25,
      stiffness: 200,
      duration: 0.6,
      staggerChildren: 0.1,
    },
  },
};

export const containerVariants:Variants = { 
      hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: {
      duration: 0.3,
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
}


export const smoothScale:Variants = {

 hidden: {
    opacity: 0,
    scale: 0.9,
    rotate: -2,
  },
  show: {
    opacity: 1,
    scale: 1,
    rotate: 0,
 
      transition: {
      type: "spring",
      damping: 20,
      stiffness: 100,
      mass: 0.9,
    },
  },
}
export const mobileItemVariants:Variants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      damping: 20,
      stiffness: 300,
    },
  },
};

export  const cardVariants:Variants = {
    hidden: {
      opacity: 0,
      y: 20,
      scale: 0.95,
    },
    show: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94],
        type: "tween",
      },
    },
  };



    export const hoverVariants:Variants = {
    hover: {
      y: -8,
      scale: 1.02,
      transition: {
        duration: 0.4,
        ease: [0.25, 0.46, 0.45, 0.94],
        type: "tween",
      },
    },
  };

  export const imageVariants:Variants = {
    hover: {
      scale: 1.08,
      transition: {
        duration: 0.6,
        ease: [0.25, 0.46, 0.45, 0.94],
      },
    },
  };

  export const contentVariants:Variants = {
    hover: {
      scale: 1.03,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
  };

/// ANIMATION 

export  const pulseGlow:TargetAndTransition = {
  scale: [1, 1.05, 1],
  opacity: [0.7, 1, 0.7],
  transition: {
    duration: 3,
    repeat: Infinity,
    ease: "easeInOut",
    repeatType: "loop" as const,
  },
};
export const floatingAnimation:TargetAndTransition= {
    
    y: [0, -8, 0],
    transition: {
      duration: 4,
      repeat: Infinity,
      repeatType: "loop",
      ease: "easeInOut",
    },

};